import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { createAuthRedirectState, persistPostAuthRedirectFromLocation } from '../utils/authRedirect';

interface RequireAuthProps {
  children: JSX.Element;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { isAuthenticated, isEmailVerified, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Or your loading component
  }

  if (!isAuthenticated || !isEmailVerified) {
    // Persist redirect in session storage so it survives hard redirects/reloads.
    persistPostAuthRedirectFromLocation(location);
    return <Navigate to="/auth" state={createAuthRedirectState(location)} replace />;
  }

  return children;
}